import { cn } from '@/styles/utils';
import * as React from 'react';
import { createPortal } from 'react-dom';

interface TruncatedCellProps {
  content: string;
  className?: string;
  tooltipTitle?: string;
  tooltipClassName?: string;
}

const TruncatedCell: React.FC<TruncatedCellProps> = ({
  content,
  className,
  tooltipTitle = '제품설명',
  tooltipClassName,
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [tooltipPosition, setTooltipPosition] = React.useState({
    top: 0,
    left: 0,
  });
  const cellRef = React.useRef<HTMLDivElement>(null);

  // 텍스트가 넘치는지 확인하는 함수
  const isTextTruncated = () => {
    const element = cellRef.current;
    if (!element) return false;

    return element.scrollWidth > element.clientWidth;
  };

  const handleMouseEnter = () => {
    if (isTextTruncated()) {
      const rect = cellRef.current?.getBoundingClientRect();
      if (rect) {
        // 팝업 위치 계산
        setTooltipPosition({
          top: rect.bottom - 6,
          left: rect.left + 93,
        });
      }
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  // 포탈을 사용하여 팝업을 body 바로 아래에 렌더링
  const renderTooltip = () => {
    if (!showTooltip) return null;

    return createPortal(
      <div
        className={cn(
          'fixed z-50 w-72 min-h-31 h-auto px-4 py-5 gap-2 bg-white border-1 border-[#A7ADB7] shadow-sm rounded-xl',
          tooltipClassName,
        )}
        style={{
          top: `${tooltipPosition.top}px`,
          left: `${tooltipPosition.left}px`,
        }}
      >
        {tooltipTitle && (
          <div className="body-16sb text-[#222222] mb-4">{tooltipTitle}</div>
        )}
        <div className="body-16r text-[#6D717D]">{content}</div>
      </div>,
      document.body,
    );
  };

  return (
    <div
      className="relative w-full h-full"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={cellRef}
        className={cn(
          'truncate whitespace-nowrap overflow-hidden max-w-full text-clip',
          className,
        )}
      >
        {content}
      </div>

      {renderTooltip()}
    </div>
  );
};

export default TruncatedCell;
